import { type FC } from 'react';
import { motion } from 'framer-motion';
import { useTopLoadingBar } from './useTopLoadingBar';
import styles from './topLoadingBar.module.scss';

/** Длительность одного пробега «кометы» по полосе (сек). */
const COMET_DURATION = 1.15;

/**
 * Глобальная полоса загрузки под хедером. Отражает переход между страницами:
 * старт — при смене URL, финиш — когда новый роут смонтирован. Полностью
 * декоративна и изолирована; состояние берёт из внешнего стора через хук.
 */
export const TopLoadingBar: FC = () => {
  const { progress, inverseProgress, opacity, visible, reduceMotion } =
    useTopLoadingBar();

  return (
    <motion.div
      className={styles['top-loading-bar']}
      style={{ opacity }}
      aria-hidden="true"
    >
      <motion.div
        className={styles['top-loading-bar__fill']}
        style={{ scaleX: progress }}
      >
        {visible && !reduceMotion && (
          <motion.div
            className={styles['top-loading-bar__shimmer']}
            style={{ scaleX: inverseProgress }}
          >
            <motion.span
              className={styles['top-loading-bar__comet']}
              animate={{ x: ['-100%', '380%'] }}
              transition={{
                duration: COMET_DURATION,
                ease: 'linear',
                repeat: Infinity
              }}
            />
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );
};
